'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFile = exports.downloadFile = undefined;

var _mimeTypes = require('mime-types');

var _fileSaver = require('file-saver');

/**
 * Downloads and exports a file to the system through the browser
 * Supported browsers can be found at @link https://github.com/eligrey/FileSaver.js/
 * @param {Blob} blob 
 * @param {string} fileName 
 */
var downloadFile = exports.downloadFile = function downloadFile(data, fileName) {
  var mimeType = (0, _mimeTypes.lookup)(fileName);
  var blob = new Blob([data], { type: mimeType });

  (0, _fileSaver.saveAs)(blob, fileName);
};

/**
 * Attempts to open file in a new tab
 * https://medium.com/@storrisi/how-to-show-a-pdf-stream-on-a-react-client-without-any-library-36220fee60cb
 * @param {any} data 
 * @param {string} type 
 */
var openFile = exports.openFile = function openFile(data, type) {
  var file = new Blob([data], { type: type });
  var url = window.URL.createObjectURL(file);
  window.open(url);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/FileDownloadService.js
// module id = 813
// module chunks = 10